import { render, staticRenderFns } from "./DasboardStatsTraffic.vue?vue&type=template&id=6fcf9721&"
import script from "./DasboardStatsTraffic.vue?vue&type=script&lang=js&"
export * from "./DasboardStatsTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports